export const API_FAILED = 'Something Went Wrong!';
